export default "__VITE_ASSET__D33o0bOl__"